var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 313.65 184.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 99.35,
    y1: 67.36,
    x2: 205.91,
    y2: 178.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8cc63f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#4fa176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#0071bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 126.72,
    y1: 41.06,
    x2: 233.34,
    y2: 152,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "martoms studios logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134,66.67l13.84,13.84a12.49,12.49,0,0,0,17.67,0l22.67-22.67L210.8,35.17a12.49,12.49,0,0,0,0-17.67L197,3.66a12.49,12.49,0,0,0-17.67,0L165.46,17.5a12.49,12.49,0,0,1-17.67,0L134,3.66a12.49,12.49,0,0,0-17.67,0L93.61,26.33,62.1,57.84,30.6,89.34,3.66,116a12.49,12.49,0,0,0,0,17.67L17.5,147.45a12.49,12.49,0,0,0,17.67,0l26.93-26.6L93.61,89.34l22.67-22.67A12.49,12.49,0,0,1,134,66.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "298.4 105.1 266.89 73.59 235.39 42.08 203.88 73.59 156.14 121.33 124.64 89.82 93.13 121.33 124.64 152.83 156.14 184.34 187.65 152.83 235.39 105.1 266.89 136.6 282.14 151.85 313.65 120.35 298.4 105.1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsLogo);
export default __webpack_public_path__ + "static/media/ms-logo.7d8f50dda2f841f84a21335fb0223537.svg";
export { ForwardRef as ReactComponent };